import './Documentation.css'
import { Helmet } from 'react-helmet';

export default function Documentation() {
    return (
        <section id="documentation">
            <Helmet>
                <title>Документация</title>
            </Helmet>
            <div className="documentation">
                <h1>Сертификаты и инструкции</h1>
                <br />
                <p>Товары, представленные на сайте нашей компании, безопасны и имеют все необходимые разрешительные документы.</p>
                <div className="rows">
                    <div className="row">
                        <div className="col-md-4">
                            <h4>Мойки колёс для стройплощадок</h4>
                            <p>
                                <a href="/media/Docs/washers_cert.pdf" target="_blank" className='link doc_link'>Сертификат соответствия</a>
                                <span className="infobadge">:<br /> до 22 марта 2028 </span>
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <h4>Секционный полимерный мусоросброс</h4>
                            <p>
                                <a href='/media/Docs/sert_mussi_soot_b.pdf' target="_blank" className='link doc_link'>Сертификат соответствия</a>
                                <span className="infobadge">:<br /> до 05 ноября 2028</span>
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <h4>Игровое оборудование</h4>
                            <p>
                                <a href="/media/Docs/certs_playcomplex_td.pdf" rel="lightbox" target="_blank" className='link doc_link'>Сертификат соответствия</a>
                                <span className="infobadge">:<br /> до 03 декабря 2027</span>
                                <br />
                                <a href="/media/Docs/playgrounds-sanit.pdf" rel="lightbox" target="_blank" className='link doc_link'>Санитарный сертификат</a>
                                <span className="infobadge">:<br /> бессрочно</span>
                                <br />
                                <a href="/media/Docs/otkaznoe_pog-bez_str-01-02.pdf" rel="lightbox" target="_blank" className='link doc_link'>Отказное письмо о пожарной безопасности</a>
                                <span className="infobadge">:<br /> бессрочно</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section >
    )
}